/**
 * TutorCoachingVideosScreen — « Vidéos de formation » (route `videos-coaching`), à la place de
 * `tutor/home/tutorResources/TutorVideos.js` pour un tuteur dont l'espace est allumé : une ligne,
 * « Formation du tuteur », qui ouvre « Ta formation ». La branche « Le coaching » n'est ouverte par
 * aucun geste : elle n'est pas portée.
 */
import React from "react"

import { TutorCoachingVideosPage } from "../../../../../../design-system/tutor"
import { useTutorCoachingVideosState } from "./useTutorCoachingVideosState"

export function TutorCoachingVideosScreen() {
    return <TutorCoachingVideosPage {...useTutorCoachingVideosState()} />
}
